import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDUpDa6WI5646YjL7pCTN5rwPx1jJd9FnQ",
  authDomain: "management-146ec.firebaseapp.com",
  projectId: "management-146ec",
  storageBucket: "management-146ec.firebasestorage.app",
  messagingSenderId: "771161935257",
  appId: "1:771161935257:web:96a28f9311e086bd3d5708",
  measurementId: "G-021LZC91M9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);
const storage = getStorage(app);

export { app, auth, database, storage };